import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EligibilitycalculatorsearchComponent } from './components/eligibilitycalculatorsearch/eligibilitycalculatorsearch.component';

const routes: Routes = [
  {
    path: 'eligibilitycalculatorsearch',
    component: EligibilitycalculatorsearchComponent
  },
  {
    path: '',
    component: EligibilitycalculatorsearchComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }